// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Lecturer } from './lecturer';
import type { IdReference } from './idReference';

export type CourseModuleSettingsCorrector = Lecturer | IdReference | null;
